import { render } from "./UnCryptoOwner.vue?vue&type=template&id=d239c746"
import script from "./UnCryptoOwner.vue?vue&type=script&lang=js"
export * from "./UnCryptoOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__